__turbopack_context__.v({
  "collapsible-container": "course-sidebar-container-module-scss-module__-6mU1q__collapsible-container",
  "collapsible-secondary-actions": "course-sidebar-container-module-scss-module__-6mU1q__collapsible-secondary-actions",
  "collapsible-title": "course-sidebar-container-module-scss-module__-6mU1q__collapsible-title",
  "container": "course-sidebar-container-module-scss-module__-6mU1q__container",
  "enrolled-message": "course-sidebar-container-module-scss-module__-6mU1q__enrolled-message",
  "enrolled-message-container": "course-sidebar-container-module-scss-module__-6mU1q__enrolled-message-container",
  "non-sidebar-container": "course-sidebar-container-module-scss-module__-6mU1q__non-sidebar-container",
  "sidebar-container": "course-sidebar-container-module-scss-module__-6mU1q__sidebar-container",
  "skeleton": "course-sidebar-container-module-scss-module__-6mU1q__skeleton",
});
